export const ORDER_FIELDS = `
  fragment OrderFields on Order {
    id
    user
    payment {
      paymentProvider
      currency
      status
      totalAmount
      totalRefundAmount
      totalRefundDetails
      refundType
      refunds
      paymentIntent {
        id
        client_secret
        last_payment_error
      }
      paymentMethod {
        id
        card {
          brand
          funding
          last4
          exp_month
          exp_year
        }
      }
    }
    type
    state
    completedAt
  }
`
